import { Payment } from '@model/payment';
import { Globals } from '@theme/utils/globals';
import { CONFIRMATION } from '@theme/utils/functions';
import { VALIDATION } from '@theme/utils/functions';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, Input } from '@angular/core';
import { EmitterService } from '@service/emitter/emitter.service';
import { PaymentShowComponent } from '../payment-show/payment-show.component';
import { PaymentAddComponent } from '@locataire/payment/payment-add/payment-add.component';
import { InvoicePaymentService } from '@service/invoice-payment/invoice-payment.service';
import { TrusteeProviderPaymentAddComponent } from '../trustee-provider-payment-add/trustee-provider-payment-add.component';
import { TrusteeProviderPaymentShowComponent } from '../trustee-provider-payment-show/trustee-provider-payment-show.component';


@Component({
  selector: 'app-trustee-provider-payment-list',
  templateUrl: './trustee-provider-payment-list.component.html',
  styleUrls: ['./trustee-provider-payment-list.component.scss']
})
export class TrusteeProviderPaymentListComponent implements OnInit {
  @Input() payments: any[]
  @Input() action: boolean = true
  dtOptions: any = {};
  etat: boolean = false
  confirmation = CONFIRMATION
  validation = VALIDATION
  global = {country: Globals.country, device: Globals.device}
  total: number = 0;
  userSession = Globals.user

  constructor(
    private modalService: NgbModal,
    private paymentService: InvoicePaymentService,
    private emitter: EmitterService
  ) {
  }

  ngOnInit(): void {
    this.etat = this.payments ? true : false;
    if(this.etat){
      this.payments.forEach(item => { return this.total = this.total + item?.montant })
    }
    this.dtOptions = Globals.dataTable;
    this.emitter.event.subscribe((data) => {
      if (data.action === 'PAYMENT_ADD') {
        this.appendToList(data.payload);
      }
      if (data.action === 'PAYMENT_UPDATED' || data.action === 'PAYMENT_VALIDATE') {
        this.update(data.payload);
      }
    });
  }

  appendToList(item): void {
    this.payments.unshift(...item);
  }
  update(item): void {
    const index = this.payments.findIndex(x => x.uuid === item.uuid);
    if (index !== -1) {
      this.payments[index] = item;
    }
  }
  editPayment(row) {
    this.paymentService.setInvoicePayment(row)
    this.paymentService.edit = true
    this.paymentService.type = row.type
    this.modal(TrusteeProviderPaymentAddComponent, 'modal-basic-title', 'xl', true, 'static')
  }
  showPayment(row) {
    this.paymentService.setInvoicePayment(row)
    this.modal(TrusteeProviderPaymentShowComponent, 'modal-basic-title', 'xl', true, 'static')
  }
  validatePayment(row){
    Swal.fire({
      title: '',
      text: 'Voulez-vous vraiment valider cet paiement ?',
      showCancelButton: true,
      showCloseButton: true,
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Valider <i class="fas fa-check"></i>',
      confirmButtonColor: 'green',
      timer: 2500,
      reverseButtons: true
    }).then((willDelete) => {
      if (willDelete.dismiss) {
      } else {
      this.paymentService.validate(row).subscribe(res => {
        if (res?.status === 'success') {
          if (row) {
            this.emitter.emit({action: 'PAYMENT_VALIDATE', payload: res?.data});
          }
        }
      });
      }
    });
  }
  printerPayment(row): void {
    this.paymentService.getPrinter('SHOW', this.userSession?.agencyKey, this.userSession?.uuid, row?.uuid);
  }
  delete(item) {
    Swal.fire({
      title: '',
      text: 'Voulez-vous vraiment supprimer cet enrégistrement ?',
      showCancelButton: true,
      showCloseButton: true,
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Supprimer <i class="feather icon-trash"></i>',
      confirmButtonColor: '#d33',
      timer: 2500,
      reverseButtons: true
    }).then((willDelete) => {
      if (willDelete.dismiss) {
      } else {
        this.paymentService.getDelete(item.uuid).subscribe((res: any) => {
          if (res?.code === 200) {
            const index = this.payments.findIndex(x => x.uuid === item.uuid);
            if (index !== -1) {
              this.payments.splice(index, 1);
            }
            Swal.fire('', res?.message, res?.status);
          }
        });
      }
    });
  }
  modal(component, type, size, center, backdrop) {
    this.modalService.open(component, {
      ariaLabelledBy: type,
      size: size,
      centered: center,
      backdrop: backdrop
    }).result.then((result) => {

    }, (reason) => {

    });
  }
}
